import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SidebarComponent } from './sidebar/sidebar.component';
import { NavbarComponent } from './navbar/navbar.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';


@NgModule({
  declarations: [SidebarComponent, NavbarComponent],
  exports: [SidebarComponent, NavbarComponent],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    NgbModule
  ]
})
export class PartialsModule { }
